import { gql } from "@apollo/client";

export const GET_TASKS = gql`
  query Tasks($filters: TaskFiltersInput) {
    tasks(filters: $filters) {
      count
      results {
        id
        name
        priority
        status
        content
        created
        assigned {
          user_id
          name
          short_name
          icon_color
        }
        unread_comments
        state
      }
      deletePermission
    }
  }
`;

export const GET_TASK = gql`
  query Task($id: Int!) {
    task(id: $id) {
      id
      name
      priority
      status
      content
      itemId
      itemModelId
      companyId
      createdById
      created
      modified
      assigned {
        user_id
        name
        short_name
        icon_color
      }
      unread_comments
      state
    }
  }
`;

export const CREATE_TASK = gql`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      id
      name
      priority
      status
      content
      assigned {
        user_id
        name
      }
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($id: Int!, $input: UpdateTaskInput!) {
    updateTask(id: $id, input: $input) {
      id
      name
      priority
      status
      content
      assigned {
        user_id
        name
      }
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($id: Int!) {
    deleteTask(id: $id)
  }
`;

export const GET_TASKS_CALENDAR = gql`
  query TasksCalendar($filters: TaskFiltersInput, $firstDay: String!, $lastDay: String!) {
    tasksCalendar(filters: $filters, firstDay: $firstDay, lastDay: $lastDay) {
      title
      priority
      status
      link
      dueTo
    }
  }
`;

export const GET_TASKS_STATS = gql`
  query TasksStats {
    tasksStats {
      labels {
        text
        color
      }
    }
  }
`;
